import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ProtectedRoute } from '../ProtectedRoute';

const OrgWideSettingsPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/OrgWideSettingsPage')
); // prettier-ignore
const SettingsListPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/SettingsListPage')
); // prettier-ignore
const UserGroupsPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/UserGroupsPage')
); // prettier-ignore
const IPWhitelistPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/IPWhitelistPage')
); // prettier-ignore

export enum AdminHubOrgWideSettingsRoutes {
  AdminHubOrgWideSettings = '/:domain/admin-hub/org-wide-settings',
  AdminHubOrgWideSettingsUserGroups = '/:domain/admin-hub/org-wide-settings/user-groups',
  AdminHubOrgWideSettingsIPWhitelist = '/:domain/admin-hub/org-wide-settings/ip-whitelist'
}

export const getOrgWideSettingsRoutes = (): RouteObject[] => {
  return [
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettings,
      element: <ProtectedRoute component={OrgWideSettingsPage} role="L1" />,
      children: [
        {
          path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettings,
          element: <SettingsListPage />
        }
      ]
    },
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettingsUserGroups,
      element: <ProtectedRoute component={UserGroupsPage} role="L1" />
    },
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettingsIPWhitelist,
      element: <ProtectedRoute component={IPWhitelistPage} role="L0" />
    }
  ];
};
